import { render } from "./PersonProfile.vue?vue&type=template&id=b2383ee4"
import script from "./PersonProfile.vue?vue&type=script&lang=js"
export * from "./PersonProfile.vue?vue&type=script&lang=js"

import "./PersonProfile.vue?vue&type=style&index=0&id=b2383ee4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__